import { defaultPathogenicityColor } from "../../../../common/helpers/colors";
import { getPathogenicityColorByAllNames as getColor } from "../../../../common/helpers/Constant";

export const getZscoreColor = (score) => {
  if (typeof score !== "number") return defaultPathogenicityColor;
  if (Number.isNaN(score)) return defaultPathogenicityColor;

  if (score <= -2) return getColor("Benign");
  if (score <= -1) return getColor("Likely Benign");
  if (score < 1) return getColor("Uncertain Significance");
  if (score < 2) return getColor("Likely Pathogenic");
  return getColor("Pathogenic");
};
